"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APIProducerCard = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const APIProducerCard = props => {
  var _props$title, _props$description, _props$color;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "";
  const color = (_props$color = props === null || props === void 0 ? void 0 : props.color) !== null && _props$color !== void 0 ? _props$color : "primary400";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "producer-header-card-container ph-border-".concat(color)
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "heading-medium"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "ph-highlighter-card ph-bg-".concat(color)
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph mt-3"
  }, description));
};
exports.APIProducerCard = APIProducerCard;